export default __webpack_public_path__ + "35cf4a1d7aea1cce42cc690313b6b009.png";